import { render } from "./ExpandPanel.vue?vue&type=template&id=ca563654&scoped=true&ts=true"
import script from "./ExpandPanel.vue?vue&type=script&lang=ts"
export * from "./ExpandPanel.vue?vue&type=script&lang=ts"

import "./ExpandPanel.vue?vue&type=style&index=0&id=ca563654&scoped=true&lang=css"

import exportComponent from "/home/vsts/work/1/s/my-pages-ts/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca563654"]])

export default __exports__